module.exports = __webpack_public_path__ + "img/pbtm2.08acbba3.png";